<template>
  <div class="container">
    <a-row>
      <a-layout-content>
        <div class="mb-24">
          <template v-if="contextRodzajeOfert()">
            <T1BreadcrumbsPlaceholder v-if="!breadcrumbsReady" />
            <T1Breadcrumbs
              v-show="breadcrumbsReady"
              :homeLink="true"
              :items="getBreadcrumbs()"
            />
          </template>
          <template v-else-if="!standard()">
            <T1BreadcrumbsPlaceholder v-if="!breadcrumbsReady" />
            <T1Breadcrumbs
              v-show="breadcrumbsReady"
              :homeLink="true"
              :activeTail="false"
              :extraItem="addExtraItems()"
              :locid="regionLocid"
            />
          </template>
          <template v-else>
            <T1Breadcrumbs
              class="mb-24"
              :homeLink="false"
              :items="getStandardBreadcrumbs()"
            />
          </template>
        </div>
        <T1MainSearcher
          :isSkione="getDomainType('', 'skione') ? true : false"
          :offersLoading="offersLoading"
          :groupTitle="groupTitle"
	  :isFront=false
        />
        <T1SzukajOferty @offersLoading="getOffersLoading" />
      </a-layout-content>
    </a-row>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import T1BreadcrumbsPlaceholder from "./T1Placeholders/T1BreadcrumbsPlaceholder";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1MainSearcher from "./T1Searchers/T1MainSearcher";
import T1SzukajOferty from "./T1SzukajOferty";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  name: "szukaj-content",
  mixins: [domainTypeMixin],
  data: () => ({
    breadcrumbsReady: false,
    regionsCrumbs: [],
    regionLocid: "",
    groupTitle: "",
    offersLoading: true,
  }),
  methods: {
    getOffersLoading(value) {
      this.offersLoading = value;
    },
    addExtraItems() {
      let param = this.$route.query;
      let extraItems = [];
      let holidaysContextUrl = CONFIG.defaultContext;

      extraItems.push({
        name: "Lista ofert",
        link: holidaysContextUrl + "/oferty.xml",
      });

      if (this.regionLocid == CONFIG.locid && !param["locid"]) {
        extraItems.push({
          name: CONFIG.panstwo_nazwapl,
          link: holidaysContextUrl + "/oferty.xml",
        });
      }
      return extraItems;
    },
    standard() {
      let path = this.$route.path;
      if (path.indexOf("/oferta/szukaj.xml") !== -1) {
        return true;
      } else {
        return false;
      }
    },
    getStandardBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push(
        { name: "Skione.pl", link: "/" },
        { name: "Zestawienie ofert", link: "/oferta/szukaj.xml" },
        { name: "Oferty", link: "" }
      );
      return crumbsArr;
    },
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push(
        { name: "Rodzaje ofert", link: "/rodzaj-oferty.xml" },
        { name: this.groupTitle, link: "" }
      );
      return crumbsArr;
    },
    contextRodzajeOfert() {
      let rContext = this.$route.path;
      let isRodzajeOfert = false;
      if (rContext.indexOf("/rodzaj-oferty/") !== -1) {
        isRodzajeOfert = true;
      }
      return isRodzajeOfert;
    },
  },
  mounted() {
    let that = this;
    this.$root.$on("update:regionLocid", (val1) => {
      that.regionLocid = val1;
    });
    this.$root.$on("update:groupTitle", (val1) => {
      that.groupTitle = val1;
    });
    this.$root.$on("update:breadcrumbsReady", (val1) => {
      that.breadcrumbsReady = val1;
    });
  },
  components: {
    T1BreadcrumbsPlaceholder,
    T1Breadcrumbs,
    T1MainSearcher,
    T1SzukajOferty,
  },
};
</script>
